require('../modules/es7.object.get-own-property-descriptors');
require('../modules/es7.string.pad-start');
require('../modules/es7.string.pad-end');
module.exports = require('./4');



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/socialtravel/shared/~/core-js/stage/3.js
// module id = 867
// module chunks = 0